export interface PasswordRule {
    id: string;
    test: (pw: string) => boolean;
    label: string;
}

export const passwordRules: PasswordRule[] = [
    {id: "length", test: pw => pw.length >= 8, label: "password.rules.length"},
    {id: "upper", test: pw => /[A-Z]/.test(pw), label: "password.rules.upper"},
    {id: "lower", test: pw => /[a-z]/.test(pw), label: "password.rules.lower"},
    {id: "number", test: pw => /[0-9]/.test(pw), label: "password.rules.number"},
    {id: "special", test: pw => /[^A-Za-z0-9]/.test(pw), label: "password.rules.special"}
];